export const LOG = 'LOG';
export const ANALYZE_AUDIO = 'ANALYZE_AUDIO';
export const ANALYZE_AUDIO_SUCCESS = 'ANALYZE_AUDIO_SUCCESS';

export const PROCESS_ITEMS = 'PROCESS_ITEMS';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_ITEMS_AAXML = 'SET_ITEMS_AAXML';
export const GO_TO_PREVIOUS_ITEM = 'GO_TO_PREVIOUS_ITEM';
export const GO_TO_NEXT_ITEM = 'GO_TO_NEXT_ITEM';
export const GO_TO_ITEM = 'GO_TO_ITEM';
export const SHOW_RESULTS = 'SHOW_RESULTS';
export const RECOVER_SAVED_STATE = 'RECOVER_SAVED_STATE';
export const RESTART_EXERCISE = 'RESTART_EXERCISE';
export const START_RECORDING = 'START_RECORDING';
export const STOP_RECORDING = 'STOP_RECORDING';
export const SET_EXERCISE_READY = 'SET_EXERCISE_READY';
export const SET_ITEMS_TO_SHOW = 'SET_ITEMS_TO_SHOW';
export const SET_ITEM_MARKED_TEXT = 'SET_ITEM_MARKED_TEXT';
export const ANSWER_QUESTION = 'ANSWER_QUESTION';
export const SET_WORDS_PER_MINUTE = 'SET_WORDS_PER_MINUTE';
export const SET_WORDS_RECOGNISED = 'SET_WORDS_RECOGNISED';

export const SHOW_FEEDBACK = 'SHOW_FEEDBACK';
export const HIDE_FEEDBACK = 'HIDE_FEEDBACK';

export const SET_INTERACTION = 'SET_INTERACTION';
export const SET_VERSION = 'SET_VERSION';
export const SET_TEST_MODE = 'SET_TEST_MODE';
export const SET_TEST_SENT = 'SET_TEST_SENT';
export const SET_EX_CONTAINER = 'SET_EX_CONTAINER';
export const SET_ITEMS_KEYS = 'SET_ITEMS_KEYS';
export const MARK_ITEM_WITH_AUDIO = 'MARK_ITEM_WITH_AUDIO';
export const SET_BASE_PATH = 'SET_BASE_PATH';

export const SET_AUDIO_PREFIX = 'SET_AUDIO_PREFIX';
export const SET_AUDIO_ENABLED = 'SET_AUDIO_ENABLED';

export const SET_UPLOAD_URLS = 'SET_UPLOAD_URLS';
export const GET_CHUNK = 'GET_CHUNK';
export const SET_CHUNK = 'SET_CHUNK';
export const ENABLE_RECORDING = 'ENABLE_RECORDING';
export const DISABLE_RECORDING = 'DISABLE_RECORDING';
